"use client"

import clsx from "clsx"
import { NpHomePageRatingData } from "src/components/home/types"
import {
  npPagePxClassName,
  npPageWidthClassName,
  npSectionMtClassName,
} from "src/components/np-design/components/constants"
import { NpCarouselArrow } from "src/components/np-design/components/NpCarouselArrow"
import { NpPaginationDots } from "src/components/np-design/components/NpPaginationDots"
import { NpReview } from "src/components/np-design/components/NpReview"
import { useEmbla } from "src/utilities/embla"

export type NpHomePageReviewsSectionProps = {
  reviews: NpHomePageRatingData[]
}

export const NpHomePageReviewsSection = ({ reviews }: NpHomePageReviewsSectionProps) => {
  const { ref, embla, scrollSnaps, activeIndex, hasPrev, hasNext, justifyCenter } = useEmbla({
    slidesToScroll: 1,
    align: "end",
  })

  if (!reviews.length) {
    return null
  }

  return (
    <section className={clsx(npSectionMtClassName, npPagePxClassName)}>
      <div className={clsx(npPageWidthClassName, "embla flex flex-col items-center gap-6 overflow-hidden")}>
        <div ref={ref} className="embla__viewport overflow-hidden">
          <div
            className={clsx("embla__container -ml-4 flex lg:-ml-6 xl:-ml-10", {
              "justify-center": justifyCenter,
            })}
          >
            {reviews.map((review, index) => (
              <div
                key={index}
                className="embla__slide min-w-0 shrink-0 grow-0 basis-full pl-4 sm:basis-1/2 lg:basis-1/3 lg:pl-6 xl:basis-1/4 xl:pl-10"
              >
                <NpReview review={review} />
              </div>
            ))}
          </div>
        </div>

        <div className="grid-cols-auto-3 grid w-full sm:grid-cols-3">
          <div />

          <NpPaginationDots count={scrollSnaps.length} activeIndex={activeIndex} />

          {(hasPrev || hasNext) && (
            <div className="ml-auto hidden gap-2 sm:flex">
              {hasPrev && <NpCarouselArrow side="left" onClick={() => embla?.scrollPrev()} />}
              {hasNext && <NpCarouselArrow side="right" onClick={() => embla?.scrollNext()} />}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
